import api from "./api";

export interface Scholarship {
  _id: string;
  studentId: string;
  branchId: string;
  percentage: number;
  assignedBy: {
    _id: string;
    firstName: string;
    lastName: string;
  };
  assignedDate: string;
  reason?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  studentId?: {
    studentId: string;
    userId: {
      firstName: string;
      lastName: string;
    };
  };
}

export interface ScholarshipData {
  studentId: string;
  percentage: number;
  reason?: string;
}

export const offerScholarship = async (
  data: ScholarshipData
): Promise<Scholarship> => {
  const response = await api.post("/scholarships/offer", data);
  return response.data.data;
};

export const revokeScholarship = async (
  studentId: string
): Promise<Scholarship> => {
  const response = await api.put(`/scholarships/revoke/${studentId}`);
  return response.data.data;
};

export const getScholarships = async (params?: {
  page?: number;
  limit?: number;
  studentId?: string;
  isActive?: boolean;
  branchId?: string;
}): Promise<{ data: Scholarship[]; pagination: any }> => {
  const response = await api.get("/scholarships", { params });
  return response.data;
};

export const getStudentScholarship = async (
  studentId: string
): Promise<Scholarship | null> => {
  const response = await api.get(`/scholarships/student/${studentId}`);
  return response.data.data || null;
};
